import { CSVImport, type ColumnMapping } from '../shared/CSVImport';

const TUTOR_FIELDS: ColumnMapping[] = [
  { csvHeader: '', targetField: 'firstName', required: true },
  { csvHeader: '', targetField: 'lastName', required: true },
  { csvHeader: '', targetField: 'email', required: true },
  { csvHeader: '', targetField: 'phone' },
  { csvHeader: '', targetField: 'employmentRelationship' },
  { csvHeader: '', targetField: 'status', required: false },
];

export const TutorImport = () => (
  <CSVImport resourceName="tutors" targetFields={TUTOR_FIELDS} />
);
